import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { ValidationError } from '../../../../../domain/error.model';
import { Schedule } from '../../../../../domain/schedule.model';
import { LsnErrorStateMatcher } from '../../../../shared/middleware/error-state-matcher';
import { DialogAction } from '../../../store/dialog.action';
import { ErrorsState } from '../../../store/errors.state';
import { ScheduleAction } from '../../../store/schedule.action';

@Component({
    selector: 'app-schedule-editor-dialog',
    templateUrl: './schedule-editor-dialog.component.html',
    styleUrls: ['./schedule-editor-dialog.component.scss']
})
export class ScheduleEditorDialogComponent implements OnInit {
    schedule: Schedule;
    matchers = {
        startTime: new LsnErrorStateMatcher(this, 'startTime'),
        endTime: new LsnErrorStateMatcher(this, 'endTime'),
    };

    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];

    constructor(private store: Store,
                @Inject(MAT_DIALOG_DATA) data: Schedule) {
        if (data === null) {
            this.schedule = new Schedule();
        } else {
            this.schedule = cloneDeep(data);
        }
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getAsideErrors).subscribe(errors => this.errors = errors)
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    save() {
        this.store.dispatch(new ScheduleAction.Save(this.schedule));
    }

    close() {
        this.store.dispatch(new DialogAction.CloseAll());
    }
}
